import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    unknown: {
        id: "general.unknown",
    },
});

export default messages;
